import React, { useEffect, useState } from 'react'
import { eye_icon, left_arrow } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import StarIcon from "@mui/icons-material/Star";

const CompletedView = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const bookingData = location?.state?.bookingData;
    const [blockDates, setBlockDates] = useState();
    const [blockToDates, setBlockToDates] = useState();
    const [adult, setAdult] = useState();
    const [child, setChild] = useState();

    useEffect(() => {
        setChild(bookingData?.booking_rooms?.map((item) => {
            return (
                item?.no_of_childs
            )
        }))
        setAdult(bookingData?.booking_rooms?.map((item) => {
            return (
                item?.no_of_adults
            )
        }))
        setBlockDates(bookingData?.from_date)
        setBlockToDates(bookingData?.to_date)
    }, [])

    console.log('datum', bookingData)
    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                    Bookings - Completed
                </h2>
            </div>

            <div className='d-flex ac-js gap-2'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>

            <div className='d-flex gap-5 mb-4'>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Property Name
                    </h4>
                    <input type="text" value={bookingData?.property?.name} disabled className="input-pop ps-2 w-100" placeholder="Property Name" />
                </div>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Owner Name
                    </h4>
                    <input type="text" value={bookingData?.property?.owner?.name} disabled className="input-pop ps-2 w-100" placeholder="Owner Name" />
                </div>

            </div>

            <div className='d-flex gap-5 mb-4'>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        User Name
                    </h4>
                    <input type="text" value={bookingData?.user?.name} disabled className="input-pop ps-2 w-100" placeholder="Owner Name" />
                </div>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Pricing
                    </h4>
                    <input type="text" value={bookingData?.total_amount} disabled className="input-pop ps-2 w-100" placeholder="Booking Dates" />
                </div>

            </div>

            <div className='d-flex gap-5 mb-4'>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Date
                    </h4>
                    <input type="text" value={moment(bookingData?.from_date).format("DD-MM-YYYY")} disabled className="input-pop ps-2 w-100" placeholder="Date" />
                </div>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Booking ID
                    </h4>
                    <input type="text" value={bookingData?.booking_id} disabled className="input-pop ps-2 w-100" placeholder="Booking ID" />
                </div>

            </div>

            <div className='d-flex gap-5 mb-4'>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Booked ON
                    </h4>
                    <input type="text" value={moment(bookingData?.created_at).format("DD-MM-YYYY")} disabled className="input-pop ps-2 w-100" placeholder="Booked ON" />
                </div>

                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Check IN
                    </h4>
                    <input type="text" value={`${moment(bookingData?.from_date).format("DD-MM-YYYY") || ""}, ${bookingData?.check_in || ""}`} disabled className="input-pop ps-2 w-100" placeholder="Room Category" />
                </div>
            </div>

            <div className='d-flex gap-5 mb-4'>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Check OUT
                    </h4>
                    <input type="text" value={`${moment(bookingData?.to_date).add(1,"days").format("DD-MM-YYYY") || ""}, ${bookingData?.check_out || ""}`} disabled className="input-pop ps-2 w-100" placeholder="Check OUT" />
                </div>
                <div className='col-md-5'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Room Type
                    </h4>
                    <input type="text" value={bookingData?.room_category?.name} disabled className="input-pop ps-2 w-100" placeholder="Room Type" />
                </div>




            </div >

            <div className='d-flex gap-5 mb-4'>

                <div className='col-md-5'>

                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        persons :
                    </h4>
                    <div className='d-flex gap-3'>
                        <div className="w-50 d-flex ac-js gap-2" >
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  primary1">  Adults</h4>
                            <input type="text" value={bookingData?.total_adults} className="input-pop ps-2 w-100" placeholder="Adult : 10" />
                        </div>
                        <div className="w-50 d-flex ac-js gap-2">
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">  Childs</h4>
                            <input type="text" value={bookingData?.total_childs} className="input-pop ps-2 w-100" placeholder="Children : 10" />
                        </div>
                    </div>

                </div>

            </div>

            <div className='d-flex gap-5 mb-4'>

                <div className='col-md-7'>
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Review
                    </h4>
                    <div className='input-pop ps-2 w-100 h-100'>
                        {bookingData?.review?.map((item) => {
                            return (
                                <div>
                                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  primary1 d-flex ac-js gap-2 mb-0 mt-3">
                                        {item?.reviewer?.type}  ({item?.reviewer?.name}) {item?.reviewer?.type == "User" && (
                                            <div className="d-flex">
                                                {Array.from({ length: Math.round(item?.rating) })?.map((item, ind) => {
                                                    return (
                                                        <p className="mb-0" key={ind}>
                                                            <StarIcon style={{ color: "#ffc108" }} />{" "}
                                                        </p>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </h4>
                                    <p className="cust-btn ps-2 w-100 " placeholder="Reason For Cancel" >{item?.review ? item?.review : "Null"}</p>
                                </div>
                            )
                        })}
                    </div>

                </div>
            </div>
        </div >
    )
}

export default CompletedView